import usStates from 'constants/usStates';
import { get } from 'lodash';
import React from 'react';
import { IAddress } from 'types/transaction';
import { IUser, IUserAddress } from 'types/user';

const AddressFormatComponent: React.FC<{
  addressDetail?: IAddress | IUserAddress | IUser;
  separateLines?: boolean;
}> = ({ addressDetail, separateLines = false }) => {
  if (!addressDetail) return null;
  const address = `${addressDetail.address1}, ${addressDetail.address2 ? `, ${addressDetail.address2}` : ''}`;
  const { city } = addressDetail;
  const isCityMentioned = city?.toLowerCase().includes('city');
  const stateCode = addressDetail.state;
  const { zip } = addressDetail;
  const fullScheduleAddress = `${address} ${city}${isCityMentioned ? '' : ' City'}, ${get(
    usStates,
    stateCode || '',
  )} ${zip}`;
  return separateLines ? (
    <div>
      <div>{addressDetail.address1}</div>
      {addressDetail.address2 && <div>{addressDetail.address2}</div>}
      <div>{`${city}${isCityMentioned ? '' : ' City'}, ${get(usStates, stateCode || '')} ${zip}`}</div>
    </div>
  ) : (
    <div>{fullScheduleAddress}</div>
  );
};

export default AddressFormatComponent;
